

import { Control } from 'react-hook-form';
import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { ProfileFormValues } from '../ProfileFormSchema';

interface DateFieldsProps {
  control: Control<ProfileFormValues>;
}

export function DateFields({ control }: DateFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={control}
        name="date_began_training"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date Began Training</FormLabel>
            <FormControl>
              <Input 
                type="date" 
                {...field}
                value={field.value ? new Date(field.value).toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  field.onChange(e.target.value ? new Date(e.target.value) : null);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="date_achieved_belt"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date Achieved Current Belt</FormLabel>
            <FormControl>
              <Input 
                type="date" 
                {...field}
                value={field.value ? new Date(field.value).toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  field.onChange(e.target.value ? new Date(e.target.value) : null);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
